import { useCallback, useEffect, useRef, useState } from "react"

export const useCooldownAction = (action, delay = 1000) => {
  const [isPending, setIsPending] = useState(false)
  const timeoutRef = useRef(null)

  const execute = useCallback((...args) => {
    if (isPending) return

    setIsPending(true)
    action(...args)

    timeoutRef.current = setTimeout(() => {
      setIsPending(false)
    }, delay)
  }, [action, isPending, delay])

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current)
  }, [])

  return { execute, isPending }
}

